import { useEffect, useRef, useState } from "react";
import {
  Col,
  Offcanvas,
  Row,
  Tab,
  Nav,
  Modal,
  Table,
  Dropdown,
  Overlay,
  Popover,
  Button, // Added Dropdown for note actions
} from "react-bootstrap";
import {
  Calendar,
  CheckSquare,
  FileChartLine,
  FileCheck,
  StickyNote,
} from "lucide-react";
import imgs from "../../../Utils/assets/img/faces/5.jpg"; // Assuming this path is correct in the user's environment
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAddressBook,
  faAngleLeft,
  faAngleRight,
  faBriefcase,
  faBuildingColumns,
  faCalendar,
  faCalendarCheck,
  faClock,
  faDollar,
  faDollarSign,
  faEllipsisVertical,
  faEnvelope,
  faFile,
  faFileLines,
  faFilter,
  faFlag,
  faLandmarkDome,
  faLocationCrosshairs,
  faLocationDot,
  faMapLocationDot,
  faMessage,
  faNoteSticky,
  faPenFancy,
  faPersonWalkingArrowRight,
  faPhone,
  faPlus,
  faSortDown,
  faSquareCheck,
  faTimes,
  faUser,
  faUserCircle,
  faUserLock,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import {
  FaFacebook,
  FaLinkedin,
  FaWhatsapp,
  FaTwitterSquare,
  FaInstagramSquare,
  FaStickyNote,
} from "react-icons/fa";
import useLocalStorageState from "use-local-storage-state"; // Assuming this hook is available
import {
  DeleteRequest,
  GetRequest,
  PostRequest,
  PutRequest,
} from "../../../Utils/hooks/ApiHandler"; // Assuming these utilities are available
import { useNavigate } from "react-router-dom"; // Assuming react-router-dom is used
import DocumentsList from "../DocumentsList"; // Assuming this component is available
import { DetailsSkeleton } from "../../../Utils/skeletonLoader/DetailsSkeleton"; // Assuming this component is available
import { toast } from "sonner"; // Assuming sonner is used for toasts
import DeleteModal from "../../DeleteModal"; // Assuming this component is available
import { CKEditor } from "@ckeditor/ckeditor5-react"; // Assuming CKEditor is installed
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"; // Assuming CKEditor is installed
import { DescriptionTooltip } from "../../../Utils/helpers/descriptionTooltip/DescriptionTooltip"

import { WhatsappModal } from "../../../pages/WhatsappModal";
import {
  checkTwilioIntegration,
  formatDate,
  formatTime,
  formatToINR,
  maskContactNumber,
  putCommaInLeadsValue,
} from "../../../Utils/helpers/commonhelper";
import { Tasks } from "../../Forms/Tasks";
import Select from "react-select";
import "../../../Utils/assets/css/table.css";
import { EditContactOffcanvas } from "../../../pages/EditContactOffcanvas";
import { CloneContact } from "../../education/Contacts/ContactModule/CloneContactForm";
import { Meetings } from "../leads/Meetings";
import { CreateDeal } from "../../deals/CreateDeal";
// import { CreateLead } from '../../leads/CreateLead';
// import { UpdateDeal } from "../../deals/UpdateDeal"
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
import { DealDetails } from "../../deals/DealDetails";
import { LeadsDetails } from "../leads/LeadsDetails";
import { FaLinkedinIn } from "react-icons/fa6";
import { baseURL } from "../../../Utils/constants/constant";
import { useGetRequest } from "../../../Utils/hooks/QueryHandler"
import { IconActivity } from "@tabler/icons-react";
import { ContactActivity } from "../../../pages/ContactActivity";
import GlobalCallModal from "../../ivr/GlobalCallModal";
import TwilioIntegrationForm from "../../ivr/TwilioIntegrationForm";
import DyanmicCallLog from '../../ivr/DynamicCallLog';
import { UnauthViewModal } from "../../../pages/UnauthViewModal";
import { UnauthorizedTableState } from "../../../pages/UnauthorizedTableState";
import { useOutsideClickHandler } from "../../../Utils/hooks/useOutsideClickHandler";
import { ContactTasks } from "./ContactDetailsModule/ContactTasks";
import { ContactDetailsHeader } from "./ContactDetailsModule/ContactDetailsHeader";
import { ContactInfo } from "./ContactDetailsModule/ContactInfo";
import { ContactProspectsInfo } from "./ContactDetailsModule/ContactProspectsInfo";
import { ContactNotes } from "./ContactDetailsModule/ContactNotes";

const ExpandableNote = ({ note }) => {
  const [expanded, setExpanded] = useState(false);
  const [needsTruncate, setNeedsTruncate] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    const el = textRef.current;
    if (!el) return;

    const checkTruncate = () => {
      let lineHeight = parseInt(window.getComputedStyle(el).lineHeight);

      // fallback if browser returns "normal"
      if (isNaN(lineHeight)) {
        lineHeight = 20; // approx line height in px
      }

      const maxHeight = lineHeight * 3;

      if (el.scrollHeight > maxHeight + 2) {
        setNeedsTruncate(true);
      } else {
        setNeedsTruncate(false);
      }
    };

    checkTruncate();

    // observer for resize/DOM changes
    const observer = new ResizeObserver(checkTruncate);
    observer.observe(el);

    return () => observer.disconnect();
  }, [note.notes]);

  return (
    <div style={{ fontSize: 14, color: "black" }}>
      <span
        ref={textRef}
        style={{
          display: "-webkit-box",
          WebkitLineClamp: expanded ? "unset" : 3,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "normal",
          overflowWrap: "anywhere",
          wordBreak: "break-word",
        }}
        dangerouslySetInnerHTML={{ __html: note.notes }}
      />
      {needsTruncate && (
        <span
          onClick={() => setExpanded(!expanded)}
          style={{
            color: "blue",
            cursor: "pointer",
            marginLeft: 4,
            fontWeight: 500,
          }}
        >
          {expanded ? "Less" : "More"}
        </span>
      )}
    </div>
  );
};

export default ExpandableNote;

export const ContactDetails = ({
  show,
  id,
  allContacts,
  dataForEdit,
  refetch,
  setShowContactDetailsCanvas,
  showContactDetailsCanvas,
  onlyDetail,
  onCanvasClose
}) => {
  const [customer, setCustomer] = useLocalStorageState("customer");
  const navigate = useNavigate();

  // Extract tokens from session
  const customerId = customer?.customer_details?.customer_id;
  const token = customer?.token?.authorization;
  const rf = customer?.token?.authentication;
  const headers = {
    authentication: rf,
    Authorization: token,
  };
  const extras = { customer, setCustomer, rf, navigate };

  const [targets, setTargets] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [contactDetails, setContactDetails] = useState({});
  const [contactLeads, setContactLeads] = useState({});
  // parsed data states
  const [parsedUserPhone, setParsedUserPhone] = useState([]);
  const [parsedUserEmail, setParsedUserEmail] = useState([]);
  const [parsedTimezone, setParsedTimezone] = useState({});

  // permission setup for conntacts
  const permission = customer.customer_details?.permission
  const contactPermssion = permission?.filter(c => c.module_name === "contact")
  const user_type = Number(customer.customer_details?.user_type)
  const contactGrant = {
    isView: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "contact")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "contact")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "contact")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "contact")?.delete)) : true,
  }

  const contactMeetingGrant = {
    isView: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "meeting")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "meeting")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "meeting")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "meeting")?.delete)) : true,
  }
  const contactDocGrant = {
    isView: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "document")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "document")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "document")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "document")?.delete)) : true,
  }

  const [nextPrevious, setNextPrevious] = useState(
    !onlyDetail && allContacts?.findIndex((obj) => obj.id === id)
  );
  // whatsapp modal state
  const [whatsappModalOpen, setWhatsAppModalOpen] = useState(false);
  // contact id common variable
  const contactId = allContacts?.[nextPrevious]?.id || id;
  const [emailTemplateArray, setEmailTemplateArray] = useState(null);
  const [templateData, setTemplateData] = useState(null);
  const statusDropdownRef = useRef(null);
  const [showStatusDropdown, setShowStatusDropdown] = useState(false);
  // Email recipients state (tag input)
  const [emailRecipients, setEmailRecipients] = useState([]);
  const [currentEmailInput, setCurrentEmailInput] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(null); // Track which note's dropdown is open

  const [showIntegrationModal, setShowIntegrationModal] = useState({
    whatsapp: false,
    sms: false,
    email: false,
  });
  const [integrationStatus, setIntegrationStatus] = useState({
    whatsapp: "not_checked", // 'not_checked', 'success', 'fail'
    sms: "not_checked",
    email: "not_checked",
  });

  // const [showDealDeleteModal, setShowDealDeleteModal] = useState(false)
  const [whatsappKey, setWhatsappKey] = useState(null);
  const [smsKey, setSmsKey] = useState(null);
  const [smtpDetails, setSmtpDetails] = useState(null);
  const [apiLoading, setApiLoading] = useState({
    whatsapp: false,
    sms: false,
    email: false,
  });
  const [apiError, setApiError] = useState({
    whatsapp: null,
    sms: null,
    email: null,
  });
  // state for message modal
  const [showMessageModal, setShowMessageModal] = useState({
    whatsapp: false,
    sms: false,
    email: false,
  });
  // state for storing the contact data
  const [messageData, setMessageData] = useState({
    subject: "",
    body: "",
    file: null,
    notes: "",
  });
  const [isCheckingTwilio, setIsCheckingTwilio] = useState(false);
  const [globalDiller, setGlobalDiller] = useState(false);
  const [showtwilioModal, setShowTwilioModal] = useState(false);
  const [callLogOpen, setCallLogOpen] = useState(false);

  const [deleteDocument, setDeleteDocument] = useState(false)
  // state to show a spinner after sending mail
  const [emailLoading, setEmailLoading] = useState(false);
  const [documents, setDocuments] = useState([])
  const [documentToDelete, setDocumentToDelete] = useState(null)

  // contact details fetched function
  const fetchContactDetails = async () => {
    if (!contactId) return; // Ensure contactId exists before fetching
    try {
      setLoading(true); // Set loading to true when starting
      const res = await GetRequest(
        `/contacts/ContactDetails/${customerId}/${contactId}`,
        { headers },
        extras
      );
      setContactDetails(res.data[0]);
      setContactLeads(res.data);
      // setLeads([]);
      const parsedPhoneData = res.data[0]?.user_phone
        ? JSON.parse(res.data[0]?.user_phone)
        : null;
      parsedPhoneData && setParsedUserPhone(parsedPhoneData);
      // parsed for email
      const parsedEmailData = res.data[0]?.user_email
        ? JSON.parse(res.data[0]?.user_email)
        : null;
      parsedEmailData && setParsedUserEmail(parsedEmailData);

      // parsed time zone
      const timezone = res.data[0]?.timezone
        ? JSON.parse(res.data[0]?.timezone)
        : null;
      timezone && setParsedTimezone(timezone);
      setLoading(false); // Set loading to false when done
    } catch (err) {
      setLoading(false); // Ensure loading is false even on error
    }
  };

  // for calling
  const handleGlobalCallChange = () => {
    setGlobalDiller(false);
  };

  const checkTwilio = async () => {
    if (isCheckingTwilio) return;
    setIsCheckingTwilio(true);
    try {
      const res = await checkTwilioIntegration(customerId, headers, extras)
      if (res.status === "fail" || res.success === false) {
        setShowTwilioModal(true);
      }
      if (res.status === "success") {
        setGlobalDiller(true);
      }

    } catch (error) {
      console.error(error)
    } finally {
      setIsCheckingTwilio(false);
    }
  }

  useEffect(() => {
    if (show && contactId !== undefined) {
      fetchContactDetails();
      // fetchNotes(contactId); // Pass contactId to fetchNotes
    }
  }, [show, contactId, customerId]); // Added customerId to dependencies

  useEffect(() => {
    if (onlyDetail) return
    const parsedEmails = JSON.parse(allContacts[nextPrevious]?.user_email);
    const emailsArr = parsedEmails?.map((e) => e.email);
    setEmailRecipients(emailsArr !== null && emailsArr);
  }, []);

  // useeffect to close the template dropdown
  useOutsideClickHandler({
    objRef: statusDropdownRef,
    isDropdown: showStatusDropdown,
    setDropdown: setShowStatusDropdown
  })

  // Handle email input for tag system
  const handleEmailInputKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      addEmailTag();
    }
  };

  // Add email tag
  const addEmailTag = () => {
    const email = currentEmailInput.trim();
    // Check if email is empty
    if (!email) {
      toast.error("Please enter an email address");
      return;
    }
    // Check if email is valid
    if (!isValidEmail(email)) {
      toast.error("Please enter a valid email address");
      return;
    }
    // Check if email already exists
    if (emailRecipients.includes(email)) {
      toast.error("Email address already added");
      return;
    }
    // Add email if all checks pass
    setEmailRecipients((prev) => [...prev, email]);
    setCurrentEmailInput("");
  };

  // Remove email tag
  const removeEmailTag = (emailToRemove) => {
    setEmailRecipients((prev) =>
      prev.filter((email) => email !== emailToRemove)
    );
  };

  // Validate email format
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // to store the message data
  const handleMessageInputChange = (e) => {
    const { name, value } = e.target;
    setMessageData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const docsApiUrl = `contacts/fetchDocuments/${customerId}/${contactId}`
  const {
    data: documentData,
    error,
    refetch: fetchDocument,
    isError,
    isLoading,
  } = useGetRequest(docsApiUrl, "getDocument", headers, extras)

  // Update documents
  useEffect(() => {
    if (documentData?.status === "success") {
      setDocuments(documentData?.data)
    } else if (isError) {
      console.error("Error fetching documents:", error)
    }
  }, [documentData, isError, error])

  const handleSendMessage = async (type) => {
    try {
      const payload = {
        subject: messageData.subject,
        body: messageData.body,
        notes: messageData.notes,
        email_document: messageData.file,
        customer_id: customer.customer_details?.customer_id,
        to_id: contactId,
        module_name: "contact",
        user_login_id: customer.customer_details?.id,
        user_email: emailRecipients || [],
      };
      let endpoint = "";
      if (type === "whatsapp") {
        endpoint = "whatsapp/sendMessage";
      } else if (type === "sms") {
        endpoint = "sms/sendMessage";
      } else if (type === "email") {
        endpoint = "common/sendMail";
        setEmailLoading(true);
      }
      const response = await PostRequest(
        endpoint,
        payload,
        true, // Set to true if sending files
        { headers },
        extras
      );
      if (response.status === "fail") {
        toast.error(response.message);
        setEmailLoading(false);
        return;
      }
      if (response.status === "success") {
        setEmailLoading(false);
        toast.success(`Message sent successfully via ${type}`);
        setShowMessageModal((prev) => ({ ...prev, [type]: false }));
        setMessageData({
          subject: "",
          body: "",
          file: null,
          notes: "",
        });
      } else {
        toast.error(response.message || `Failed to send ${type} message`);
        setEmailLoading(false);
      }
    } catch (error) {
      toast.error(error.message || `Error sending ${type} message`);
      setEmailLoading(false);
    }
  };

  // Trigger delete modal
  const onDelete = (id) => {
    setDocumentToDelete(id)
    setShowDeleteModal(true)
    setDeleteDocument(true)
  }

  const handleConfirmedDelete = async () => {
    setLoading(true)
    try {

      const item = documents.find((doc) => doc.id === documentToDelete)

      if (!item) return toast.error("no record find to delete")

      const res = await DeleteRequest(
        `/Contacts/DeleteDocuments/${contactId}/${documentToDelete}`,
        { headers },
        extras,
      )

      if (res.status !== "success" || res.status === "fail") {
        setLoading(false)
        return toast.error(res.message || "failed to delete document")
      }

      if (res.status === "success") {
        toast.success(res.message || "document deleted successfully")
        setDocuments((prevDocs) =>
          prevDocs.filter((doc) => doc.id !== documentToDelete),
        )
        setLoading(false)
        await fetchDocument()
        setDeleteDocument(false)
      }
    } catch (error) {
      setLoading(false)
      console.error("Delete error", error)
    } finally {
      setLoading(false)
      setShowDeleteModal(false)
      setDocumentToDelete(null)
    }
  }

  const handleBodyChange = (event, editor) => {
    const data = editor.getData();
    setMessageData((prev) => ({
      ...prev,
      body: data,
    }));
  };
  const handleFileChange = (e) => {
    setMessageData((prev) => ({
      ...prev,
      file: e.target.files[0],
    }));
  };

  const fetchWhatsappKey = async () => {
    setApiLoading((prev) => ({ ...prev, whatsapp: true }));
    try {
      const response = await GetRequest(
        `common/fetchWhatsappKey/${customerId}/company`,
        { headers },
        extras
      );
      if (response.status === "success") {
        setWhatsappKey(response.data);
        setWhatsAppModalOpen(true);
        setShowMessageModal({ whatsapp: true, sms: false, email: false });
      } else {
        setIntegrationStatus((prev) => ({ ...prev, whatsapp: "fail" }));
        setWhatsAppModalOpen(false);
        setShowIntegrationModal({ whatsapp: true, sms: false, email: false });
      }
    } catch (error) {
      setIntegrationStatus((prev) => ({ ...prev, whatsapp: "fail" }));
      setWhatsAppModalOpen(false);
      setShowIntegrationModal({ whatsapp: true, sms: false, email: false });
    } finally {
      setApiLoading((prev) => ({ ...prev, whatsapp: false }));
    }
  };

  const fetchSmsKey = async () => {
    setApiLoading((prev) => ({ ...prev, sms: true }));
    try {
      const response = await GetRequest(
        `common/fetchSmsKey/${customerId}/company`,
        { headers },
        extras
      );
      if (response.status === "success") {
        setSmsKey(response.data);
        setShowMessageModal({ whatsapp: false, sms: true, email: false });
      } else {
        setIntegrationStatus((prev) => ({ ...prev, sms: "fail" }));
        setShowIntegrationModal({ whatsapp: false, sms: true, email: false });
      }
    } catch (error) {
      setIntegrationStatus((prev) => ({ ...prev, sms: "fail" }));
      setShowIntegrationModal({ whatsapp: false, sms: true, email: false });
    } finally {
      setApiLoading((prev) => ({ ...prev, sms: false }));
    }
  };

  const fetchSmtpDetails = async () => {
    setApiLoading((prev) => ({ ...prev, email: true }));
    try {
      const response = await GetRequest(
        `common/fetchSMTPDetails/${customerId}/contact`,
        { headers },
        extras
      );
      if (response.status === "success") {
        setSmtpDetails(response.data); // Even if data is null
        setEmailTemplateArray(response.data && response.data);
        setShowMessageModal({ whatsapp: false, sms: false, email: true });
      } else {
        setIntegrationStatus((prev) => ({ ...prev, email: "fail" }));
        setShowIntegrationModal({ whatsapp: false, sms: false, email: true });
      }
    } catch (error) {
      setIntegrationStatus((prev) => ({ ...prev, email: "fail" }));
      setShowIntegrationModal({ whatsapp: false, sms: false, email: true });
    } finally {
      setApiLoading((prev) => ({ ...prev, email: false }));
    }
  };

  const handleEmailTempRender = async (template_id) => {
    try {
      const res = await GetRequest(
        `common/getEmailTemplate/${template_id}`,
        { headers },
        { customer, setCustomer, rf: headers.authentication, navigate }
      );
      if (res.status === "fail") {
        setTemplateData(null);
        return;
      }
      if (res.status === "success") {
        setTemplateData(res.data);
        setMessageData((prev) => ({
          ...prev,
          subject: res.data.subject || "",
          body: res.data.body || "",
        }));
        setShowStatusDropdown(false); // Close dropdown after selection
        return;
      }
    } catch (error) {
      toast.error("Error Fetching Template");
      return;
    }
  };
  const [expanded, setExpanded] = useState(false);
  const [expandeds, setExpandeds] = useState(false);
  const [expandedNew, setExpandedNew] = useState(false);

  const fullAddress = `${contactDetails?.address ? contactDetails.address : "-"} `;

  return (
    <div className="d-flex w-100">
      <Offcanvas
        className="w-100"
        id="contactDetailsOffcanvas"
        placement="end"
        backdrop="static"
        show={show}
        onHide={() => onCanvasClose()}
        style={{
          padding: "10px",
          // filter: showDetails ? " brightness(0.5)" : "",
        }}
      >
        <Offcanvas.Body className="pt-0" style={{ overflow: "hidden" }}>
          {loading ? (
            <DetailsSkeleton />
          ) : (
            <>
              {
                contactId &&
                <ContactDetailsHeader
                  onlyDetail={onlyDetail}
                  nextPrevious={nextPrevious}
                  setNextPrevious={setNextPrevious}
                  fetchWhatsappKey={fetchWhatsappKey}
                  fetchSmsKey={fetchSmsKey}
                  fetchSmtpDetails={fetchSmtpDetails}
                  apiLoading={apiLoading}
                  integrationStatus={integrationStatus}
                  checkTwilio={checkTwilio}
                  isCheckingTwilio={isCheckingTwilio}
                  setCallLogOpen={setCallLogOpen}
                  // setShowAddDealOffcanvas={}
                  contactGrant={contactGrant}
                  onCanvasClose={onCanvasClose}
                  contactId={contactId}
                  showContactDetailsCanvas={showContactDetailsCanvas}
                  setShowContactDetailsCanvas={setShowContactDetailsCanvas}
                  fetchContactDetails={fetchContactDetails}
                  allContacts={allContacts}
                  styles={styles}
                  refetch={refetch}
                />
              }
              <div
                className=" pt-4"
                style={{
                  borderRadius: "15px",
                  background: "#f9f9f9",
                  height: "94%",
                }}
              >
                <Row className="ms-0 w-100 h-100 pe-2">

                  {/* left sided col for the whole details page */}
                  <Col
                    md={7}
                    className="ps-4 contactInformation"
                    style={{ height: "96%", paddingRight: 1, overflow: "auto" }}
                  >

                    {/* imp contact details */}
                    <div
                      className="me-2"
                      style={{
                        background: "#fff",
                        paddingTop: "12px",
                        borderRadius: "5px",
                        border: "1px solid #e0e4f8",
                        marginBottom: "10px",
                      }}
                    >
                      <div
                        className="d-flex gap-4 ms-3 mb-0 pb-0"
                        style={styles.stickyHeader}
                      >
                        <div style={{ width: "10%", marginTop: "0.5rem" }}>
                          <div
                            className="rounded-circle overflow-hidden border align-items-center border-3 d-flex justify-content-center"
                            style={{
                              width: "81px",
                              height: "81px",
                              backgroundColor: "#fff",
                              borderColor: "#7a3a5e",
                            }}
                          >
                            <img
                              src={imgs || "/placeholder.svg"}
                              alt="Contact Profile"
                              className="w-100 h-100 "
                              style={{ borderRadius: "50%" }}
                            />
                          </div>
                        </div>
                        <div
                          style={{
                            color: "#576f91",
                            fontSize: "13px",
                            fontWeight: 500,
                            width: "85%",
                            // marginTop: "0.8rem",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                          }}
                          className="d-flex justify-content-between align-items-center"
                        >
                          <div>
                            <h4
                              className="mb-1"
                              style={{
                                fontSize: "20px",
                                fontWeight: "500",
                                color: "#3c3c3c",
                              }}
                            >
                              {`${contactDetails?.salutation || ""} ${contactDetails?.first_name || ""
                                } ${contactDetails?.last_name || ""}`}{" "}
                              <span style={{ color: "#3f97fd", marginLeft: "2px" }}>
                                ({contactDetails?.contact_no ? `#${contactDetails?.contact_no}` : "-"})
                              </span>
                            </h4>
                            <p className="mb-0">
                              {contactDetails?.designation || "-"} |{" "}
                              {contactDetails?.department || "-"}
                            </p>
                          </div>
                          <div className="d-flex align-items-center gap-1" style={{ marginTop: "-2.5rem" }}>
                            <button
                              type="button"
                              className={`btn p-2 ${integrationStatus.whatsapp === "success" ? "btn-success" : "btn-whatsapp"}`}
                              style={styles.listButtonsStyles}
                              onClick={fetchWhatsappKey}
                              disabled={apiLoading.whatsapp}
                            >
                              {apiLoading.whatsapp ? (
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              ) : integrationStatus.whatsapp === "success" ? (
                                <>
                                  <FaWhatsapp style={{ fontSize: "16px" }} />
                                  <span className="ms-1">Configure</span>
                                </>
                              ) : (
                                <FaWhatsapp style={{ fontSize: "16px" }} />
                              )}
                            </button>
                            <button
                              type="button"
                              className={`btn btnss ${integrationStatus.email === "success" ? "btn-success" : "btn-primary"}`}
                              style={styles.listButtonsStyles}
                              onClick={fetchSmtpDetails}
                              disabled={apiLoading.email}
                            >
                              {apiLoading.email ? (
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              ) : integrationStatus.email === "success" ? (
                                <>
                                  <FontAwesomeIcon icon={faEnvelope} style={styles.iconStyles} />
                                  <span className="ms-1">Configure</span>
                                </>
                              ) : (
                                <FontAwesomeIcon icon={faEnvelope} style={styles.iconStyles} />
                              )}
                            </button>
                            <button type="button" className="btn btn-primary btnss" style={styles.listButtonsStyles} onClick={() => checkTwilio()} >
                              <FontAwesomeIcon icon={faPhone} style={styles.iconStyles} />
                            </button>
                            <button
                              type="button"
                              className={`btn btn-primary btnss ${integrationStatus.sms === "success" ? "btn-success" : "btn-primary"}`}
                              style={styles.listButtonsStyles}
                              onClick={fetchSmsKey}
                            >
                              {apiLoading.sms ? (
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              ) : integrationStatus.sms === "success" ? (
                                <>
                                  <FontAwesomeIcon icon={faMessage} style={styles.iconStyles} />
                                </>
                              ) : (
                                <FontAwesomeIcon icon={faMessage} style={styles.iconStyles} />
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        className="pt-0 ps-0 pb-0"
                        style={{
                          background: "transparent",
                          marginTop: "0rem",
                          marginLeft: "6.2rem",
                        }}
                      >
                        <Row className="w-100 ms-0 mb-2 ">
                          <Col
                            md={6}
                            className="mb-3 d-flex align-items-center"
                          >
                            <FontAwesomeIcon
                              icon={faEnvelope}
                              style={styles.iconsStyles}
                              className=" fs-16"
                            />
                            <div>
                              <p className="mb-0" style={styles.labels}>
                                Email
                              </p>
                              <p className="mb-0" style={styles.values}>
                                {contactDetails?.email || "-"}
                              </p>
                            </div>
                          </Col>
                          <Col
                            md={6}
                            className="mb-3 d-flex align-items-center"
                            onClick={() => checkTwilio()}
                            style={{ cursor: 'pointer' }}
                          >
                            <FontAwesomeIcon
                              icon={faPhone}
                              style={styles.iconsStyles}
                              className=" fs-16"
                            />
                            <div>
                              <p className="mb-0" style={styles.labels}>
                                Phone
                              </p>
                              <p className="mb-0" style={{
                                color: "#2e384d",
                                fontWeight: 400,
                                fontSize: ".8333rem",
                                whiteSpace: "nowrap",
                                letterSpacing: "0.25px"
                              }}>
                                {
                                  parsedUserPhone?.[0]
                                    ? `+${parsedUserPhone[0].country_code} ${maskContactNumber(parsedUserPhone[0].phone)}`
                                    : "-"
                                }
                              </p>
                            </div>
                          </Col>
                          <Col
                            md={6}
                            className="mb-3 d-flex align-items-center"
                          >
                            <FontAwesomeIcon
                              icon={faLocationDot}
                              className=" fs-16"
                              style={styles.iconsStyles}
                            />
                            <div>
                              <p className="mb-0" style={styles.labels}>
                                Location
                              </p>
                              <div className="mb-0 " style={styles.values}>
                                {/* {expandeds || !isTruncated
                                  ? fullAddress
                                  : preview + "..."}
                                {isTruncated && (
                                  <span
                                    onClick={() => setExpandeds(!expandeds)}
                                    style={{
                                      color: "#0099ff",
                                      cursor: "pointer",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    {expandeds ? "Less" : "More"}
                                  </span>
                                )} */}

                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>

                    {/* contact related details */}
                    <ContactInfo
                      checkTwilio={checkTwilio}
                      contactDetails={contactDetails}
                      parsedUserEmail={parsedUserEmail}
                      parsedUserPhone={parsedUserPhone}
                      parsedTimezone={parsedTimezone}
                      styles={styles}
                    />

                    {/* leads and deals */}
                    <ContactProspectsInfo
                      contactId={contactId}
                      contactLeads={contactLeads}
                      fetchContactDetails={fetchContactDetails}
                      contactDetails={contactDetails}
                      styles={styles}
                    />
                  </Col>

                  {/* right sided task meeting notes/ */}
                  <Col
                    md={5}
                    style={{ height: "96%", borderLeft: "1px solid #d1d4e3" }}
                    className="pt-0"
                  >
                    <Tab.Container defaultActiveKey="tasks">


                      <div className="card h-100 cardBorders">

                        {/* main headings */}
                        <div className="card-header d-flex justify-content-between align-items-center py-0  cardHeaderBorders">
                          <div style={styles.ulStyles}>
                            <div className="d-flex align-items-center gap-1 navForTasks">
                              <Nav
                                variant="pills"
                                className="nav-style-1 mb-0 d-flex flex-nowrap gap-2"
                              >
                                <Nav.Item className="me-0">
                                  <Nav.Link
                                    eventKey="tasks"
                                    className="p-2 py-2 pt-3"
                                    style={styles.navLinks}
                                  >
                                    <CheckSquare size={13} className="me-1" />{" "}
                                    <span>Task</span>
                                  </Nav.Link>
                                </Nav.Item>
                                <Nav.Item className="me-0">
                                  <Nav.Link
                                    eventKey="notes"
                                    className="p-2 py-2 pt-3"
                                    style={styles.navLinks}
                                  >
                                    <StickyNote size={13} className="me-1" />{" "}
                                    <span>Notes</span>
                                  </Nav.Link>
                                </Nav.Item>
                                <Nav.Item className="me-0">
                                  <Nav.Link
                                    eventKey="meetings"
                                    className="p-2 py-2 pt-3"
                                    style={styles.navLinks}
                                  >
                                    <Calendar size={13} className="me-1" />{" "}
                                    <span>Meetings</span>
                                  </Nav.Link>
                                </Nav.Item>
                                <Nav.Item className="me-0">
                                  <Nav.Link
                                    eventKey="documents"
                                    className="p-2 py-2 pt-3"
                                    style={styles.navLinks}
                                  >
                                    <FileCheck size={13} className="me-1" />{" "}
                                    <span>Documents</span>
                                  </Nav.Link>
                                </Nav.Item>
                                <Nav.Item className="me-0">
                                  <Nav.Link
                                    eventKey="activity"
                                    className="p-2 py-2 pt-3"
                                    style={styles.navLinks}
                                  >
                                    <IconActivity size={13} className="me-1" />{" "}
                                    <span>Activity</span>
                                  </Nav.Link>
                                </Nav.Item>
                              </Nav>
                            </div>
                          </div>
                        </div>

                        {/* main content*/}
                        <div
                          className="card-body px-0 pt-0"
                          style={{ height: "90%" }}
                        >
                          <Tab.Content className="h-100">
                            {/* task list */}
                            <Tab.Pane
                              eventKey="tasks"
                              style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                              }}
                              className="p-0 pt-2 h-100"
                            >
                              <ContactTasks
                                contactId={contactId}
                                fullAddress={fullAddress}
                                ownerId={contactDetails.owner_id}
                              />
                            </Tab.Pane>
                            {/* notes  pane */}
                            <Tab.Pane
                              eventKey="notes"
                              className="p-0 pt-2"
                              style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                                height: "calc(100vh - 13rem)",
                                overflow: "auto",
                                borderRadius: 0,
                              }}
                            >
                              <ContactNotes
                                contactId={contactId}
                                styles={styles}
                              />
                            </Tab.Pane>
                            {/* meetings */}
                            <Tab.Pane
                              eventKey="meetings"
                              className="p-0 pt-2 px-3"
                              style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                              }}
                            >
                              <div className="mt-0">
                                <Meetings
                                  leadId={contactId}
                                  email={contactDetails?.email}
                                  fullName={contactDetails?.first_name + " " + contactDetails?.last_name}
                                  module_name="contact"
                                  meetingGrant={contactMeetingGrant}
                                />
                              </div>
                            </Tab.Pane>
                            {/* document listing */}
                            <Tab.Pane
                              className="p-0 pt-2 px-0"
                              eventKey="documents"
                              style={{
                                border: "none",
                                position: "relative",
                                animation: "cardEntry 1s ease-out forwards",
                              }}
                            >
                              <DocumentsList
                                onDelete={onDelete}
                                documentData={documentData}
                                // setDocumentData={setDocumentData}
                                setDeleteDocument={setDeleteDocument}
                                documents={documents}
                                fetchDocument={fetchDocument}
                                setDocuments={setDocuments}
                                setDocumentToDelete={setDocumentToDelete}
                                documentToDelete={documentToDelete}
                                id={contactId}
                                show={show}
                                moduleType={"Contacts"}
                                docGrant={contactDocGrant}
                              />
                            </Tab.Pane>
                            <Tab.Pane
                              className="p-0 pt-2 px-0"
                              eventKey="activity"
                              style={{
                                border: "none",
                                position: "relative",
                                animation: "cardEntry 1s ease-out forwards",
                              }}
                            >
                              <div className="w-100">
                                <ContactActivity
                                  module_name={"contact"}
                                  module_id={contactId}
                                  headers={headers}
                                  extras={extras}
                                />
                              </div>
                            </Tab.Pane>
                          </Tab.Content>
                        </div>
                      </div>
                    </Tab.Container>
                  </Col>
                </Row>
              </div>
            </>
          )}
        </Offcanvas.Body>
      </Offcanvas>

      {/* Integration Error Modal */}
      <Modal
        show={
          showIntegrationModal.whatsapp ||
          showIntegrationModal.sms ||
          showIntegrationModal.email
        }
        onHide={() =>
          setShowIntegrationModal({ whatsapp: false, sms: false, email: false })
        }
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Integration Required</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p className="mb-3">
            Please contact your administrator to set up this integration.
          </p>
          <button
            className="btn btn-link p-0 text-primary"
            onClick={() => navigate("/integration/email")}
            style={{ textDecoration: "underline", fontWeight: "500" }}
          >
            Click Here
          </button>
        </Modal.Body>
      </Modal>

      {/* Message Configuration Modal (for success) */}
      {showMessageModal.email && (
        <Modal
          show={showMessageModal.sms || showMessageModal.email}
          onHide={() =>
            setShowMessageModal({ whatsapp: false, sms: false, email: false })
          }
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Modal.Title>
                {showMessageModal.sms &&
                  (smsKey ? "Send SMS" : "SMS Configuration Missing")}
                {showMessageModal.email &&
                  (smtpDetails ? "Send Email" : "Email Configuration Missing")}
              </Modal.Title>
              {/* template dropdown for email modal */}
              {showMessageModal.email && (
                <div className="position-relative">
                  <button
                    className="btn btn-primary d-flex align-items-center gap-2"
                    style={{
                      fontSize: "14px",
                      padding: "6px 12px",
                      borderRadius: "4px",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowStatusDropdown(!showStatusDropdown);
                    }}
                  >
                    Choose Template
                    <FontAwesomeIcon icon={faSortDown} />
                  </button>
                  {showStatusDropdown && (
                    <div
                      ref={statusDropdownRef}
                      className="defaultDropdown dropdown-menu show"
                      style={{
                        width: "11rem",
                        padding: "7px 0px",
                        position: "absolute",
                        right: 0,
                        marginTop: "5px",
                        zIndex: 1000,
                      }}
                    >
                      {emailTemplateArray.length > 0 ? (
                        emailTemplateArray?.map((email) => (
                          <Dropdown.Item
                            key={email.id}
                            onClick={() => handleEmailTempRender(email.id)}
                            className="fs-13 d-flex gap-2 align-items-center"
                          >
                            <FontAwesomeIcon icon={faUserLock} />{" "}
                            {email.template_name}
                          </Dropdown.Item>
                        ))
                      ) : (
                        <p className="px-3 py-1 mb-0">No templates found</p>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          </Modal.Header>
          {/* email modal body and footer section */}
          {showMessageModal.email && (
            <>
              <Modal.Body>
                {/* To Field with Tag Input */}
                <div className="mb-3">
                  <label className="form-label">To</label>
                  <div
                    className="border rounded p-2"
                    style={{ minHeight: "45px" }}
                  >
                    <div className="d-flex flex-wrap gap-1 align-items-center">
                      {emailRecipients.map((email, index) => (
                        <span
                          key={index}
                          className="badge bg-primary d-flex align-items-center gap-1"
                          style={{ fontSize: "12px" }}
                        >
                          {email}
                          <FontAwesomeIcon
                            icon={faTimes}
                            style={{ cursor: "pointer", fontSize: "10px" }}
                            onClick={() => removeEmailTag(email)}
                          />
                        </span>
                      ))}
                      <input
                        type="email"
                        className="border-0 flex-grow-1"
                        style={{ outline: "none", minWidth: "200px" }}
                        placeholder="Press ENTER to add email..."
                        value={currentEmailInput}
                        onChange={(e) => setCurrentEmailInput(e.target.value)}
                        onKeyDown={handleEmailInputKeyDown}
                      />
                    </div>
                  </div>
                  <small className="text-muted">
                    Press Enter or comma to add multiple emails
                  </small>
                </div>
                {/* subject field */}
                <div className="mb-3">
                  <label className="form-label">Subject</label>
                  <input
                    type="text"
                    className="form-control"
                    name="subject"
                    value={messageData.subject}
                    onChange={handleMessageInputChange}
                  />
                </div>
                {/* body ck editor */}
                <div className="mb-3">
                  <div className="mb-3">
                    <label className="form-label fw-bold mb-2">Body</label>
                    <div className="ckeditor-container">
                      <CKEditor
                        editor={ClassicEditor}
                        data={
                          templateData !== null
                            ? templateData.body
                            : messageData.body
                        }
                        onChange={handleBodyChange}
                        config={{
                          toolbar: [
                            "heading",
                            "|",
                            "bold",
                            "italic",
                            "link",
                            "bulletedList",
                            "numberedList",
                            "|",
                            "outdent",
                            "indent",
                            "|",
                            "blockQuote",
                            "undo",
                            "redo",
                          ],
                        }}
                      />
                    </div>
                  </div>
                  <style>
                    {`
                    .ckeditor-container {
                      border: 1px solid #ddd;
                      border-radius: 4px;
                      overflow: hidden;
                    }
                    .ck.ck-toolbar {
                      background: #f8f9fa;
                      border: none !important;
                      border-bottom: 1px solid #eee !important;
                    }
                    .ck.ck-content {
                      min-height: 150px;
                      padding: 15px !important;
                      font-family: inherit;
                      line-height: 1.5;
                    }
                    .ck.ck-button {
                      padding: 5px 8px !important;
                    }
                  `}
                  </style>
                </div>
                {/* attachments */}
                <div className="mb-3">
                  <label className="form-label">Attachment</label>
                  <input
                    type="file"
                    className="form-control"
                    onChange={handleFileChange}
                  />
                </div>
                {/* notes */}
                <div className="col-md-12 mt-4">
                  <h3 className="h5 mb-2">Notes</h3>
                  <Table bordered>
                    <thead>
                      <tr>
                        <th>SYNTAX</th>
                        <th>FIELD</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{"{{to_contact_name}}"}</td>
                        <td>Course Name</td>
                      </tr>
                      <tr>
                        <td>{"{{sender_name}}"}</td>
                        <td>Branch name</td>
                      </tr>
                      <tr>
                        <td>{"{{sender_company_name}}"}</td>
                        <td>Sender Company name</td>
                      </tr>
                      <tr>
                        <td>{"{{sender_number}}"}</td>
                        <td> Sender Number</td>
                      </tr>
                      <tr>
                        <td>{"{{sender_email}}"}</td>
                        <td> Sender Email</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </Modal.Body>
              {/* send and cancel button for email  */}
              <Modal.Footer>
                <button
                  type="button" // Changed to type="button"
                  className="btn btn-default d-flex justify-content-center"
                  style={{ height: 36, width: "90px" }}
                  onClick={() =>
                    setShowMessageModal({
                      whatsapp: false,
                      sms: false,
                      email: false,
                    })
                  }
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-default px-1 d-flex align-items-center justify-content-center gap-2"
                  style={{ height: 36, width: "130px" }}
                  onClick={() => {
                    if (showMessageModal.whatsapp)
                      handleSendMessage("whatsapp");
                    if (showMessageModal.sms) handleSendMessage("sms");
                    if (showMessageModal.email) handleSendMessage("email");
                  }}
                  disabled={emailLoading}
                >
                  {emailLoading && (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                  {emailLoading ? "Sending..." : "Send"}
                </button>
              </Modal.Footer>
            </>
          )}
        </Modal>
      )}
      {/* {emailLoading && <LoadingSpinner></LoadingSpinner>} */}
      {/* modal for whatsapp */}
      {whatsappModalOpen && (
        <WhatsappModal
          whatsappModalOpen={whatsappModalOpen}
          setWhatsAppModalOpen={setWhatsAppModalOpen}
          id={contactId}
          module_name={'contact'}
        />
      )}

      {deleteDocument && (
        <DeleteModal
          show={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onConfirm={handleConfirmedDelete}
          isLoading={loading}
          message={"Are you sure you want to permanently delete this document?"}
        />
      )}
      {/* modals for calling */}
      {callLogOpen && (
        <DyanmicCallLog
          show={callLogOpen}
          onCloseModal={() => setCallLogOpen(false)}
          module_id={contactId}
          module_name={"contact"}
        />
      )}
      {globalDiller && (
        <GlobalCallModal
          isOpen={globalDiller}
          customerId={customerId}
          loginUserId={customer?.customer_details?.id}
          phoneNumber={`${parsedUserPhone[0].country_code} ${parsedUserPhone[0].phone}`}
          onClose={handleGlobalCallChange}
          module_name={"contact"}
          module_id={contactId}
        />
      )}
      {/* {twilio modal} */}
      {showtwilioModal && (
        <TwilioIntegrationForm
          isOpen={showtwilioModal}
          onClose={() => setShowTwilioModal(false)}
        />
      )}
    </div>
  );
}

const styles = {
  lastdStyle: {
    padding: "0 !important",
  },
  bottomP: {
    fontSize: 11,
  },
  bottomH4: {
    marginBottom: 2,
  },
  buttons: {
    color: "#fff",
    fontSize: "13px",
    height: "34px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#007bff", // Example color, adjust as needed
    border: "1px solid #007bff",
  },
  filterbuttons: {
    fontSize: "13px",
    height: "34px",
    width: "34px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f8f9fa", // Example color, adjust as needed
    border: "1px solid #dee2e6",
  },
  ulStyles: {
    display: "flex",
    alignItems: "center",
    gap: "3px",
    justifyContent: "space-between",
    width: "100%",
  },
  listButtonsStyles: {
    fontSize: "13px",
    // borderBottom: '1px solid #e3e3e3',
    height: "30px",
    width: "auto",
    gap: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "2px",
    color: "#fff",
  },
  listButtonsStyless: {
    fontSize: "13px",
    // borderBottom: '1px solid #e3e3e3',
    height: "30px",
    width: "56px",
    gap: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "2px",
    color: "#fff",
  },
  navButtonsStyles: {
    fontSize: "15px",
    height: "34px",
    minWidth: "34px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "2px",
  },
  iconStyles: {
    fontSize: 13,
    color: "#fff",
  },
  emptyDivs: {
    borderRight: "1px solid #E0E4F8",
    height: "35px",
    margin: "0px 2px",
  },
  DropdownItemsStyle: {
    fontSize: ".93re",
    letterSpacing: ".0386rem",
    fontWeight: 400,
    color: "#2e384d",
  },
  navLinksStyle: {
    borderRadius: "0px",
    borderBottom: "1px solid #E0E4F8",
    borderRight: "1px solid #E0E4F8",
    fontSize: 14,
    padding: "11px",
    fontFamily: '"Inter", sans-serif !important',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  navLinksStyleLast: {
    borderRadius: "0px",
    borderBottom: "1px solid #E0E4F8",
    borderRight: "none",
    fontSize: 14,
    padding: "11px",
    fontFamily: '"Inter", sans-serif !important',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  navLinksStyleLastLast: {
    borderRadius: "0px",
    borderBottom: "1px solid #E0E4F8",
    borderRight: "none",
    fontSize: 14,
    height: "99%",
    padding: "11px",
    fontFamily: '"Inter", sans-serif !important',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  inActiveNavLinksStyle: {
    borderRadius: "0px",
    borderBottom: "1px solid #E0E4F8",
    borderRight: "1px solid #E0E4F8",
    fontSize: 14,
    padding: "11px",
    fontFamily: '"Inter", sans-serif !important',
    fontWeight: 400,

    lineHeight: 1.5,
    pointerEvents: "none",
  },
  tabContainer: {
    border: "1px solid #E0E4F8",
    borderRadius: "4px",
  },
  stickyHeader: {
    paddingBottom: "11px",
    position: "sticky",
    background: "#fff",
    top: "0px",
  },
  labels: {
    fontSize: "12px",
    color: "#B0BAC9",
    fontWeight: 400,
  },
  iconsStyles: {
    color: "#2656a8",
    border: "1px solid #e6e6e6",
    background: "#e9f1ff",
    padding: "9px",
    borderRadius: "50%",
    marginRight: "10px",
    width: "15px",
    height: "15px",
    fontSize: "13px",
  },
  values: {
    color: "#2e384d",
    fontWeight: 400,
    fontSize: ".8333rem",
  },

  navLinks: {
    color: "#848484",
    fontWeight: 500,
    fontSize: 13,
    display: "flex",
    alignItems: "center",
  },
};
